<template>
    <div class="clearfix">
        <compWrapper
            theme="primary"
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
        >
            <compFormEdit
                class="padding-top-15"
                ref="form"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <div v-if="querytype != 'query'" class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetCarrierServiceDetail,
    HttpUpdateCarrierService,
    HttpGetCarrierGroup,
    HttpGetCarrierServiceByGroupId,
    HttpGetCarrierCode,
    HttpCarrierProductLog
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    components: {
        compLog: () => import("@components/templates/log"),
    },
    data() {
        return {
            formData: {
                volumeWeight: null,
                code: "",
            },
            carrierGroupList: [],
            carrierServiceList: [],
            logList: [],
            loading: false,
        };
    },
    watch: {
        "formData.carrierGroupId": {
            immediate: true,
            handler(groupId) {
                if (!groupId) return;
                this.getCarrierService();
            },
        },
    },
    created() {
        this.getCarrierGroupList();
        if (this.querytype !== "add") {
            this.getDetail();
            this.getLog();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getCountryList"
        ]),
        getBase() {
            return [
                {
                    label: this.$t("fbb.carrieraccount.logistics_carrier", {
                        defaultValue: "物流商",
                    }),
                    key: "carrierGroupId",
                    tag: "vSelect",
                    options: this.carrierGroupList,
                    query: this.querytype !== "add",
                    on:{
                        'on-change':()=>{
                            this.getRegion();
                        }
                    }
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    query: true,
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.attach.id===this.formData.regionId)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t(
                        "fbb.carrieraccount.carrieraccount_service",
                        { defaultValue: "承运商服务" }
                    ),
                    key: "carrierServiceId",
                    tag: "vSelect",
                    options: this.carrierServiceList,
                    query: this.querytype !== "add",
                    on: {
                        "on-change": () => {
                            this.getCode();
                        },
                    },
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    valueText:
                        this.formData.carrierServiceCode +
                        "(" +
                        this.formData.carrierServiceName +
                        ")",
                },
                {
                    label: this.$t("", { defaultValue: "物流服务代码" }),
                    key: "code",
                    query: true,
                    valueText: this.formData.code,
                },
                {
                    label: this.$t("fbb.basicdata.carrier_volume", {
                        defaultValue: "体积重系数",
                    }),
                    query: this.querytype == "query",
                    key: "volumeWeight",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                    },
                },
            ];
        },
    },
    methods: {
        getCode() {
            HttpGetCarrierCode({
                carrierGroupId: this.formData.carrierGroupId,
                carrierServiceId: this.formData.carrierServiceId,
            }).then((res) => {
                if (res.data) {
                    this.formData.code = res.data.code;
                } else {
                    this.formData.code = "";
                }
            });
        },
        getRegion(){
            this.formData.regionId=this.carrierGroupList.filter(item=>item.value===this.formData.carrierGroupId)[0].attach.regionId;
        },
        async getCarrierService() {
            await HttpGetCarrierServiceByGroupId({
                carrierGroupId: this.formData.carrierGroupId,
            }).then(
                (res) => {
                    this.carrierServiceList = res.data.map((item) => {
                        return {
                            value: item.id,
                            label: `${item.carrierServiceCode}(${item.carrierServiceName})`,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getCarrierGroupList() {
            await HttpGetCarrierGroup().then(
                (res) => {
                    this.carrierGroupList = res.data.map((item) => {
                        return {
                            label: item.groupName,
                            value: item.id,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getLog () {
            await HttpCarrierProductLog({
                id: this.activeid
            }).then(res => {
                this.logList = res.data.orderLogList || [];
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async getDetail() {
            this.loading = true;
            await HttpGetCarrierServiceDetail({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            if (String(this.formData.volumeWeight).indexOf(".") !== -1) {
                return this.$VMessage.error(
                    this.$t("fbb.carrieraccount.carrier_volume_not_float", {
                        defaultValue: "体积重系数只能为正整数",
                    })
                );
            }
            this.loading = true;
            await HttpUpdateCarrierService({
                id: this.activeid,
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style>
</style>
